var $ = require('jquery');
import {FormField} from "../FormField"
import {Datepicker} from "../vue-datepicker";
import {formatMoney} from "../functions/formatMoney"


export const BalanceFilter = {
    name: 'BalanceFilter',
    components: {
        FormField,
        Datepicker
    },
    data: function () {
        return {
            search: {
                amountMin: '',
                amountMax: '',
                dateFrom: null,
                dateTo: null,
                type: '',
                status: [],
            },
            filterOpen: false
        }
    },
    mounted() {
        if (this.search.status.length > 0) {
            this.filterData();
        }
    },
    watch: {
        'search.amountMin'(val) {
            this.search.amountMin = formatMoney(val);
            this.filterData();
        },
        'search.amountMax'(val) {
            this.search.amountMax = formatMoney(val);
            this.filterData();
        },
        'search.dateFrom'() {
            this.filterData();
        },
        'search.dateTo'() {
            this.filterData();
        }
    },
    methods: {
        filterToggle() {
            this.filterOpen = !this.filterOpen;
        },

        filterData() {
            this.$parent.table.search(JSON.stringify(this.$data.search));
            this.$parent.table.draw();
        }
    },
    template: `
      <div class="filter-box" :class="{'filter-box--collapsed': !filterOpen}">
      <button class="filter-box__toggle" @click="filterToggle">
        <span v-if="filterOpen">Ukryj filtry</span>
        <span v-else>Pokaż filtry</span>
      </button>

      <div class="filter-box__filters">
        <div class="row">
          <div class="gr-9@desktop gr-12">
            <div class="filter-box__filters__table">

              <div class="filter-box__filters__column filter-box__filters__column--full">
                <div class="filter-box__filters__row">
                  <label class="filter-box__filters__label" style="font-weight: 400;">Rodzaj</label>
                  <br class="hide@tablet">
                  <div class="filter-box__filters__inputs">
                    <div class="hide@tablet">
                      <div class="checkbox">
                        <input type="checkbox" id="filter_cash_in" v-model="search.status" value="payment_prepaid"
                               @change="filterData">
                        <label for="filter_cash_in" tabindex="0">doładowania konta</label>
                      </div>
                      <div class="checkbox">
                        <input type="checkbox" id="filter_invoice" v-model="search.status" value="shipment"
                               @change="filterData">
                        <label for="filter_invoice" tabindex="0" style="white-space: nowrap;">płatność za
                          zamówienia</label>
                      </div>
                      <div class="checkbox" id="doliczenia">
                        <input type="checkbox" id="filter_charging" v-model="search.status" value="surcharge"
                               @change="filterData">
                        <label for="filter_charging" tabindex="0">doliczenia</label>
                      </div>
                    </div>

                    <div class="hide@desktop show@tablet">
                      <select class="select" v-model="search.type" @change="filterData">
                        <option selected="selected" value="">wszystkie</option>
                        <option value="payment_prepaid">doładowania konta</option>
                        <option value="shipment">płatności za zamówienia</option>
                        <option value="surcharge">doliczenia</option>
                      </select>
                    </div>
                  </div>
                </div>
              </div>

              <div class="filter-box__filters__column filter-box__filters__column--full" style="margin-top: 10px;">
                <div class="filter-box__filters__inline">
                  <div class="filter-box__filters__inputs">
                    <div is="Datepicker"
                         type="date"
                         v-model="search.dateFrom"
                         input-class="input input--center"
                         format="yyyy.MM.dd"
                         :phrases="{ok: 'OK', cancel: 'Anuluj'}"
                         placeholder="Data od"
                    ></div>
                  </div>
                  <div class="filter-box__filters__inputs">
                    <div is="Datepicker"
                         type="date"
                         v-model="search.dateTo"
                         input-class="input input--center"
                         format="yyyy.MM.dd"
                         :phrases="{ok: 'OK', cancel: 'Anuluj'}"
                         placeholder="Data do"
                    ></div>
                  </div>
                </div>
                <div class="filter-box__filters__inline">
                  <div class="filter-box__filters__inputs">
                    <div is="FormField"
                         label="Kwota od"
                         type="text"
                         inputmode="numeric"
                         suffix="PLN"
                         suffix-width="50"
                         step="0.01"
                         v-model="search.amountMin"
                    ></div>
                  </div>
                  <div class="filter-box__filters__inputs">
                    <div is="FormField"
                         label="Kwota do"
                         type="text"
                         inputmode="numeric"
                         suffix="PLN"
                         suffix-width="50"
                         step="0.01"
                         v-model="search.amountMax"
                    ></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      </div>
    `
}